import React, { useState } from 'react';

import { ProductMediaCarousel } from 'src/components/organisms/ProductMediaCarousel/ProductMediaCarousel';
import type {
  MediaItem,
  ProductMediaState,
  SetCurrentMediaPayload,
} from 'src/components/organisms/ProductMediaCarousel/types';
import * as styles from './ProductOptionsDrawerImages.styles';

const PRODUCT_OPTIONS_DRAWER_IMAGES_ID = 'product-options-drawer-images';
export const SECTION_LABEL = 'Product images';

export interface ProductOptionsDrawerImagesProps {
  media: MediaItem[];
}

export const ProductOptionsDrawerImages = ({ media }: ProductOptionsDrawerImagesProps) => {
  const [currentImage, setCurrentImage] = useState(0);
  const [navigatedBy, setNavigatedBy] = useState<ProductMediaState['navigatedBy']>(null);
  const totalImages = media.length;

  const goToImage = (mediaIndex: number) => {
    setCurrentImage(mediaIndex);
    setNavigatedBy('click');
  };

  const handleSetCurrentMedia = (payload: SetCurrentMediaPayload) => {
    setCurrentImage(payload.mediaIndex);
    setNavigatedBy(payload.navigationType);
  };

  return (
    <div css={styles.carouselWrapper} id={PRODUCT_OPTIONS_DRAWER_IMAGES_ID}>
      <ProductMediaCarousel
        currentMedia={currentImage}
        idPrefix={`${PRODUCT_OPTIONS_DRAWER_IMAGES_ID}-`}
        location="Expanded media"
        media={media}
        navigatedBy={navigatedBy}
        onNextMedia={() => goToImage(currentImage === totalImages - 1 ? 0 : currentImage + 1)}
        onPrevMedia={() => goToImage(currentImage === 0 ? totalImages - 1 : currentImage - 1)}
        sectionLabel={SECTION_LABEL}
        setCurrentMedia={handleSetCurrentMedia}
        showArrows
        showDots
        showNumberOfSlides
      />
    </div>
  );
};
